import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'primeng/tabs';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { OrderListModule } from 'primeng/orderlist';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DrawerModule } from 'primeng/drawer';

import { LandingRoutingModule } from './landing-routing.module';
import { LandingComponent } from './landing.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { FavouriteReportsComponent } from './favourite-reports/favourite-reports.component';
import { RecentReportsComponent } from './recent-reports/recent-reports.component';

import { ReportItemComponent } from './report-item/report-item.component';
import { SharedModule } from '../../shared/shared.module';
import { CalendarModule } from 'primeng/calendar';
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    LandingComponent,
    LeftMenuComponent,
    FavouriteReportsComponent,
    RecentReportsComponent,
    ReportItemComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TabsModule, 
    BadgeModule, 
    AvatarModule, 
    ButtonModule, 
    ToggleSwitchModule, 
    FormsModule, 
    SelectModule,
    CalendarModule,
    OrderListModule, 
    CheckboxModule, 
    InputTextModule, 
    RadioButtonModule, 
    MultiSelectModule, 
    MenuModule, 
    TooltipModule,
    ConfirmDialogModule,
    DrawerModule,
    LandingRoutingModule
  ],
  providers: [
    ConfirmationService
  ]
})
export class LandingModule { }
